import React, {useEffect, useState} from 'react';
import {Card, Divider, Typography, message} from 'antd';
import {useNavigate} from 'react-router-dom';
import styled from 'styled-components';
import SubBanner from '../../components/SubBanner';
import Form from '../../components/data_entry/form/Form';
import Button from '../../components/data_entry/Button';
import axios from '../../services/api';
import ENDPOINTS from '../../constants/endpoints';
import {ROUTES} from '../../constants/PathRoutes';
import {BuildFieldErrorsDict} from '../../utils/utils';
import {CLIENT_TYPE} from '../../constants/constants';
import {FIELD_NAMES} from './constants';
import PersonalDataSection from './PersonalDataSection';
import DependentSection from './DependentSection';
import AddressSection from './AddressSection';
import DocumentsSection from './DocumentsSection';
import AccessSection from './AccessSection';
import {useSiteSettings} from "../../contexts/SiteSettingsContext";

const {Title} = Typography;

const Container = styled.div`
    max-width: 1200px;
    margin: 32px auto;
    padding: 0 16px;
`;

const StyledCard = styled(Card)`
    .ant-card-body {
        padding: 32px;
    }
`;

const SectionTitle = styled(Title)`
    && {
        margin-bottom: 16px;
        font-size: 18px;
    }
`;

function getFileFromUpload(value) {
    if (!value || !Array.isArray(value) || value.length === 0) return null;
    return value[0].originFileObj || value[0];
}

export default function ClientRegister() {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const {settings} = useSiteSettings();
    const navigate = useNavigate();



    const clientType = Form.useWatch(FIELD_NAMES.CLIENT_TYPE, form);

    const onFinish = async () => {
        setLoading(true);
        try {
            const values = form.getFieldsValue(true);
            const formData = new FormData();

            formData.append('email', values[FIELD_NAMES.EMAIL]);
            formData.append('password', values[FIELD_NAMES.PASSWORD]);
            formData.append('first_name', values[FIELD_NAMES.FIRST_NAME]);
            formData.append('last_name', values[FIELD_NAMES.LAST_NAME]);
            formData.append('cpf', values[FIELD_NAMES.CPF]);
            formData.append('rg', values[FIELD_NAMES.RG] || '');
            formData.append('profession', values[FIELD_NAMES.PROFESSION] || '');
            formData.append('birth_date', values[FIELD_NAMES.BIRTH_DATE]);
            formData.append('gender', values[FIELD_NAMES.GENDER]);
            formData.append('phone', values[FIELD_NAMES.PHONE] || '');
            formData.append('client_type', values[FIELD_NAMES.CLIENT_TYPE]);
            formData.append('status', 'UNDER_REVIEW');

            const address = {
                postal_code: values[FIELD_NAMES.POSTAL_CODE] || '',
                street: values[FIELD_NAMES.STREET] || '',
                neighborhood: values[FIELD_NAMES.NEIGHBORHOOD] || '',
                number: values[FIELD_NAMES.NUMBER] || '',
                city: values[FIELD_NAMES.CITY] || '',
                state: values[FIELD_NAMES.STATE] || '',
                complement: values[FIELD_NAMES.COMPLEMENT] || '',
            };
            formData.append('addresses', JSON.stringify(address));

            const judicialFile = getFileFromUpload(values[FIELD_NAMES.JUDICIAL_TERM_PDF]);
            if (judicialFile) formData.append('judicial_term_pdf', judicialFile);
console.log(judicialFile)
            const consentFile = getFileFromUpload(values[FIELD_NAMES.CONSENT_TERM_PDF]);
            if (consentFile) formData.append('consent_term_pdf', consentFile);

            const type = values[FIELD_NAMES.CLIENT_TYPE];
            if (type === CLIENT_TYPE.PATIENT) {
                formData.append('dependent[medical_condition]', values[FIELD_NAMES.DEP_MEDICAL_CONDITION] || '');
                const medReport = getFileFromUpload(values[FIELD_NAMES.DEP_MEDICAL_REPORT_PDF]);
                if (medReport) formData.append('dependent[medical_report_pdf]', medReport);
            } else if (type === CLIENT_TYPE.PATIENT_TUTOR) {
                formData.append('dependent[first_name]', values[FIELD_NAMES.DEP_FIRST_NAME] || '');
                formData.append('dependent[last_name]', values[FIELD_NAMES.DEP_LAST_NAME] || '');
                formData.append('dependent[cpf]', values[FIELD_NAMES.DEP_CPF] || '');
                formData.append('dependent[rg]', values[FIELD_NAMES.DEP_RG] || '');
                formData.append('dependent[birth_date]', values[FIELD_NAMES.DEP_BIRTH_DATE]);
                formData.append('dependent[gender]', values[FIELD_NAMES.DEP_GENDER] || '');
                formData.append('dependent[medical_condition]', values[FIELD_NAMES.DEP_MEDICAL_CONDITION] || '');
                const medReport = getFileFromUpload(values[FIELD_NAMES.DEP_MEDICAL_REPORT_PDF]);
                if (medReport) formData.append('dependent[medical_report_pdf]', medReport);
            } else if (type === CLIENT_TYPE.PET_TUTOR) {
                formData.append('dependent[first_name]', values[FIELD_NAMES.DEP_FIRST_NAME] || '');
                formData.append('dependent[medical_condition]', values[FIELD_NAMES.DEP_MEDICAL_CONDITION] || '');
                const medReport = getFileFromUpload(values[FIELD_NAMES.DEP_MEDICAL_REPORT_PDF]);
                if (medReport) formData.append('dependent[medical_report_pdf]', medReport);
            }

            await axios.post(ENDPOINTS.AUTH_REGISTER_CLIENT, formData, {
                headers: {'Content-Type': 'multipart/form-data'},
            });
            message.success('Cadastro realizado com sucesso! Aguarde a aprovação.');
            navigate(ROUTES.AREA_ASSOCIADO_LOGIN);
        } catch (error) {
            BuildFieldErrorsDict(error, form.setFields);
        } finally {
            setLoading(false);
        }
    };

    const uploadProps = {
        beforeUpload: () => false,
        maxCount: 1,
        accept: '.pdf',
    };

    const normFile = (e) => {
        if (Array.isArray(e)) return e;
        return e?.fileList;
    };

    const fillRandom = () => {
        const rand = (n) => Math.random().toString(36).substring(2, 2 + n);
        const randDigits = (n) => Array.from({length: n}, () => Math.floor(Math.random() * 10)).join('');
        const cpf = `${randDigits(3)}.${randDigits(3)}.${randDigits(3)}-${randDigits(2)}`;
        const phone = `(${randDigits(2)}) ${randDigits(5)}-${randDigits(4)}`;
        // const password = `Teste@${randDigits(4)}`;
        const password = `Admin@123`;
        const genders = ['MALE', 'FEMALE', 'OTHER'];
        const states = ['SP', 'RJ', 'MG', 'BA', 'PR', 'RS', 'SC', 'GO', 'PE', 'CE'];
        const clientTypes = ['PATIENT', 'PATIENT_TUTOR', 'PET_TUTOR'];
        const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];

        form.setFieldsValue({
            [FIELD_NAMES.FIRST_NAME]: `Nome${rand(4)}`,
            [FIELD_NAMES.LAST_NAME]: `Sobrenome${rand(4)}`,
            [FIELD_NAMES.CPF]: cpf,
            [FIELD_NAMES.RG]: randDigits(9),
            [FIELD_NAMES.PROFESSION]: `Profissao${rand(3)}`,
            [FIELD_NAMES.BIRTH_DATE]: `${1970 + Math.floor(Math.random() * 25)}-${String(Math.floor(Math.random() * 12) + 1).padStart(2, '0')}-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')}`,
            [FIELD_NAMES.GENDER]: pick(genders),
            [FIELD_NAMES.PHONE]: phone,
            [FIELD_NAMES.CLIENT_TYPE]: pick(clientTypes),
            [FIELD_NAMES.POSTAL_CODE]: `${randDigits(5)}-${randDigits(3)}`,
            [FIELD_NAMES.STREET]: `Rua ${rand(6)}`,
            [FIELD_NAMES.NEIGHBORHOOD]: `Bairro ${rand(4)}`,
            [FIELD_NAMES.NUMBER]: String(Math.floor(Math.random() * 999) + 1),
            [FIELD_NAMES.CITY]: `Cidade${rand(4)}`,
            [FIELD_NAMES.STATE]: pick(states),
            [FIELD_NAMES.COMPLEMENT]: `Apto ${randDigits(3)}`,
            [FIELD_NAMES.DEP_MEDICAL_CONDITION]: `Condição médica de teste ${rand(6)}`,
            [FIELD_NAMES.DEP_FIRST_NAME]: `DepNome${rand(4)}`,
            [FIELD_NAMES.DEP_LAST_NAME]: `DepSobrenome${rand(4)}`,
            [FIELD_NAMES.DEP_CPF]: `${randDigits(3)}.${randDigits(3)}.${randDigits(3)}-${randDigits(2)}`,
            [FIELD_NAMES.DEP_RG]: randDigits(9),
            [FIELD_NAMES.DEP_BIRTH_DATE]: `${2005 + Math.floor(Math.random() * 15)}-${String(Math.floor(Math.random() * 12) + 1).padStart(2, '0')}-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')}`,
            [FIELD_NAMES.DEP_GENDER]: pick(genders),
            [FIELD_NAMES.EMAIL]: `teste${rand(5)}@teste.com`,
            [FIELD_NAMES.PASSWORD]: password,
            [FIELD_NAMES.CONFIRM_PASSWORD]: password,
        });
    };

    return (
        <>
            <SubBanner title="Cadastro de Associado"/>
            <Container>
                <StyledCard>
                    <Form form={form} onFinish={onFinish} autoComplete="off" layout="vertical">

                        <div style={{marginBottom: 16}}>
                            <Button onClick={fillRandom} style={{background: '#faad14', borderColor: '#faad14'}}>
                                Preencher Teste
                            </Button>
                        </div>

                        <SectionTitle level={4}>Dados Pessoais</SectionTitle>
                        <PersonalDataSection/>

                        <Divider/>

                        <SectionTitle level={4}>Dependente</SectionTitle>
                        <DependentSection
                            clientType={clientType}
                            uploadProps={uploadProps}
                            normFile={normFile}
                        />

                        <Divider/>

                        <SectionTitle level={4}>Endereço</SectionTitle>
                        <AddressSection/>

                        <Divider/>

                        <SectionTitle level={4}>Documentos</SectionTitle>
                        <DocumentsSection
                            siteSettings={settings}
                            uploadProps={uploadProps}
                            normFile={normFile}
                        />

                        <Divider/>

                        <SectionTitle level={4}>Acesso</SectionTitle>
                        <AccessSection/>

                        <div style={{textAlign: 'right', marginTop: 24}}>
                            <Button htmlType="submit" loading={loading}>
                                Cadastrar
                            </Button>
                        </div>
                    </Form>
                </StyledCard>
            </Container>
        </>
    );
}
